module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//head-bg-active.png?v=78d63bb5";